import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const COUNTRY_PATH = "/master/v1/country";

export const getCountryApi = async (params) =>
  await getRequest(COUNTRY_PATH, params);

export const getCountryByIdApi = async (id) =>
  await getRequest(`${COUNTRY_PATH}/${id}`);

export const addCountryApi = async (body) =>
  await postRequest(COUNTRY_PATH, body);

export const updateCountryApi = async (body) =>
  await putRequest(`${COUNTRY_PATH}/${body?._id}`, body);

export const deleteCountryByIdApi = async (id) =>
  await deleteRequest(`${COUNTRY_PATH}/${id}`);
